/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import "./NganHang.scss";
import { BankList } from "./BankList";
import { getFromlocalstorage } from "../../../../../component/MaHoaDuLieu";
import Notify from "../../../../../component/Notify/Notify";
import { useUser } from "../../../../../component/UserProvider/UserProvider";

function NganHang() {
  const apiUrl = process.env.REACT_APP_API_BACKEND;
  const data = JSON.parse(getFromlocalstorage("data_u"));

  const [showPopup, setShowPopup] = useState(false);
  const [selectedBank, setSelectedBank] = useState("กรุณาเลือกธนาคาร");
  const [bankList, setBankList] = useState([]);

  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");

  const [withdrawalPassword, setWithdrawalPassword] = useState("");
  const [oldWithdrawalPassword, setOldWithdrawalPassword] = useState("");

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const [message, setMessage] = useState("");
  const [type, setType] = useState("error");

  const hasFetched = useRef(false);

  const { user, fetchUser } = useUser();

  const hasOldPassword = user
    ? user.withdrawal_password !== 0
    : data.withdrawal_password !== 0;

  // =========================
  // LẤY THÔNG TIN USER
  // =========================
  useEffect(() => {
    if (data && !hasFetched.current) {
      fetchUser(data._id);
      hasFetched.current = true;
    }
  }, [data]);

  // =========================
  // RESET MẬT KHẨU CŨ
  // NẾU USER CHƯA CÓ MẬT KHẨU
  // =========================
  useEffect(() => {
    if (!hasOldPassword) {
      setOldWithdrawalPassword("");
    }
  }, [hasOldPassword]);

  // =========================
  // DANH SÁCH NGÂN HÀNG THÁI LAN
  // =========================
  useEffect(() => {
    const thaiBanks = [
      {
        id: 1,
        code: "BBL",
        shortName: "Bangkok Bank",
        name: "Bangkok Bank Public Company Limited",
        thaiName: "ธนาคารกรุงเทพ",
      },
      {
        id: 2,
        code: "KBANK",
        shortName: "Kasikornbank",
        name: "Kasikornbank Public Company Limited",
        thaiName: "ธนาคารกสิกรไทย",
      },
      {
        id: 3,
        code: "KTB",
        shortName: "Krung Thai Bank",
        name: "Krung Thai Bank Public Company Limited",
        thaiName: "ธนาคารกรุงไทย",
      },
      {
        id: 4,
        code: "SCB",
        shortName: "Siam Commercial Bank",
        name: "Siam Commercial Bank Public Company Limited",
        thaiName: "ธนาคารไทยพาณิชย์",
      },
      {
        id: 5,
        code: "BAY",
        shortName: "Krungsri",
        name: "Bank of Ayudhya Public Company Limited",
        thaiName: "ธนาคารกรุงศรีอยุธยา",
      },
      {
        id: 6,
        code: "TTB",
        shortName: "ttb",
        name: "TMBThanachart Bank Public Company Limited",
        thaiName: "ธนาคารทหารไทยธนชาต",
      },
      {
        id: 7,
        code: "GSB",
        shortName: "Government Savings Bank",
        name: "Government Savings Bank",
        thaiName: "ธนาคารออมสิน",
      },
      {
        id: 8,
        code: "BAAC",
        shortName: "BAAC",
        name: "Bank for Agriculture and Agricultural Cooperatives",
        thaiName: "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
      },
      {
        id: 9,
        code: "GHB",
        shortName: "Government Housing Bank",
        name: "Government Housing Bank",
        thaiName: "ธนาคารอาคารสงเคราะห์",
      },
      {
        id: 10,
        code: "CIMBT",
        shortName: "CIMB Thai",
        name: "CIMB Thai Bank Public Company Limited",
        thaiName: "ธนาคารซีไอเอ็มบี ไทย",
      },
      {
        id: 11,
        code: "UOBT",
        shortName: "UOB Thailand",
        name: "United Overseas Bank (Thai) Public Company Limited",
        thaiName: "ธนาคารยูโอบี",
      },
      {
        id: 12,
        code: "KKP",
        shortName: "Kiatnakin Phatra",
        name: "Kiatnakin Phatra Bank Public Company Limited",
        thaiName: "ธนาคารเกียรตินาคินภัทร",
      },
      {
        id: 13,
        code: "TISCO",
        shortName: "TISCO",
        name: "TISCO Bank Public Company Limited",
        thaiName: "ธนาคารทิสโก้",
      },
      {
        id: 14,
        code: "ICBCT",
        shortName: "ICBC Thai",
        name: "Industrial and Commercial Bank of China (Thai)",
        thaiName: "ธนาคารไอซีบีซี (ไทย)",
      },
      {
        id: 15,
        code: "LHFG",
        shortName: "LH Bank",
        name: "Land and Houses Bank Public Company Limited",
        thaiName: "ธนาคารแลนด์ แอนด์ เฮ้าส์",
      },
    ];

    setBankList(thaiBanks);
  }, []);

  // =========================
  // CẬP NHẬT NGÂN HÀNG
  // =========================
  const handleSubmitBank = async (e) => {
    e.preventDefault();

    if (!selectedBank || selectedBank === "กรุณาเลือกธนาคาร") {
      setMessage("กรุณาเลือกธนาคาร");
      setType("error");
      return;
    }

    if (!accountNumber) {
      setMessage("กรุณากรอกหมายเลขบัญชี");
      setType("error");
      return;
    }

    if (!accountName) {
      setMessage("กรุณากรอกชื่อเจ้าของบัญชี");
      setType("error");
      return;
    }

    try {
      const resBank = await fetch(`${apiUrl}/postbank/${data._id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          bank_name: selectedBank,
          bank_account_number: accountNumber,
          bank_account_name: accountName,
        }),
      });

      const bankResult = await resBank.json();

      if (!resBank.ok) {
        setMessage(
          bankResult.message || "อัปเดตบัญชีธนาคารไม่สำเร็จ"
        );
        setType("error");
        return;
      }

      setMessage("เชื่อมโยงบัญชีธนาคารสำเร็จ!");
      setType("success");

      await fetchUser(data._id);

      setAccountNumber("");
      setAccountName("");
      setSelectedBank("กรุณาเลือกธนาคาร");
    } catch (error) {
      setMessage("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      setType("error");
    }
  };

  // =========================
  // CẬP NHẬT MẬT KHẨU RÚT TIỀN
  // =========================
  const handleSubmitPassword = async (e) => {
    e.preventDefault();

    if (hasOldPassword && !oldWithdrawalPassword) {
      setMessage("กรุณากรอกรหัสผ่านเดิม");
      setType("error");
      return;
    }

    if (!withdrawalPassword) {
      setMessage("กรุณากรอกรหัสผ่านถอนเงินใหม่");
      setType("error");
      return;
    }

    try {
      const body = hasOldPassword
        ? {
            withdrawal_password_old: oldWithdrawalPassword,
            withdrawal_password: withdrawalPassword,
          }
        : {
            withdrawal_password: withdrawalPassword,
          };

      const resPass = await fetch(
        `${apiUrl}/postmkruttien/${data._id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );

      const passResult = await resPass.json();

      if (!resPass.ok) {
        setMessage(
          passResult.message === "Mật khẩu cũ không đúng"
            ? "รหัสผ่านเดิมไม่ถูกต้อง"
            : "อัปเดตรหัสผ่านถอนเงินไม่สำเร็จ"
        );

        setType("error");
        return;
      }

      setMessage("อัปเดตรหัสผ่านถอนเงินสำเร็จ!");
      setType("success");

      await fetchUser(data._id);

      setWithdrawalPassword("");
      setOldWithdrawalPassword("");
    } catch (error) {
      setMessage("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      setType("error");
    }
  };

  // =========================
  // RESET FORM
  // =========================
  const handleReset = () => {
    setAccountNumber("");
    setAccountName("");
    setWithdrawalPassword("");
    setOldWithdrawalPassword("");
    setSelectedBank("กรุณาเลือกธนาคาร");
  };

  return (
    <>
      <div className="withdraw_nganhang">
        <div className="withdraw_nganhang_littel"></div>

        {/* CHỌN NGÂN HÀNG */}
        <div
          className="withdraw_nganhang_input_tong width_pass border_bottom"
          onClick={() => setShowPopup(true)}
        >
          <div className="withdraw_nganhang_title_input">
            ธนาคาร
          </div>

          <div className="withdraw_nganhang_input">
            {selectedBank}
          </div>

          <div className="withdraw_nganhang_arrow">
            <img src="/caidat/arrow.png" alt="" />
          </div>
        </div>

        {/* SỐ TÀI KHOẢN */}
        <div className="withdraw_nganhang_input_tong width_pass border_bottom">
          <div className="withdraw_nganhang_title_input">
            หมายเลขบัญชีธนาคาร
          </div>

          <div className="withdraw_nganhang_input">
            <input
              type="text"
              placeholder={
                user?.bank_account_number || "กรอกหมายเลขบัญชี"
              }
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
            />
          </div>
        </div>

        {/* TÊN CHỦ TÀI KHOẢN */}
        <div className="withdraw_nganhang_input_tong width_pass border_bottom">
          <div className="withdraw_nganhang_title_input">
            ชื่อเจ้าของบัญชี
          </div>

          <div className="withdraw_nganhang_input">
            <input
              type="text"
              placeholder={
                user?.bank_account_name || "กรอกชื่อเจ้าของบัญชี"
              }
              value={accountName}
              onChange={(e) => setAccountName(e.target.value)}
            />
          </div>
        </div>

        {/* MẬT KHẨU CŨ */}
        {hasOldPassword && (
          <div className="withdraw_nganhang_input_tong width_pass border_bottom">
            <div className="withdraw_nganhang_title_input">
              รหัสผ่านเดิม
            </div>

            <div className="withdraw_nganhang_input">
              <input
                type={showOldPassword ? "text" : "password"}
                placeholder="รหัสผ่านเดิม"
                value={oldWithdrawalPassword}
                onChange={(e) =>
                  setOldWithdrawalPassword(e.target.value)
                }
              />
            </div>
          </div>
        )}

        {/* MẬT KHẨU RÚT TIỀN */}
        <div className="withdraw_nganhang_input_tong width_pass border_bottom">
          <div className="withdraw_nganhang_title_input">
            รหัสผ่านถอนเงิน
          </div>

          <div className="withdraw_nganhang_input">
            <input
              type={showNewPassword ? "text" : "password"}
              placeholder="รหัสผ่านถอนเงิน"
              value={withdrawalPassword}
              onChange={(e) =>
                setWithdrawalPassword(e.target.value)
              }
            />
          </div>
        </div>

        {/* BUTTON */}
        <div className="withdraw_nganhang_submit_btn">
          <button
            type="button"
            className="withdraw_nganhang_submit_btn_btngui"
            onClick={handleSubmitBank}
          >
            อัปเดตธนาคาร
          </button>

          <button
            type="button"
            className="withdraw_nganhang_submit_btn_btngui"
            onClick={handleSubmitPassword}
          >
            อัปเดตรหัสผ่าน
          </button>

          <button
            type="button"
            className="withdraw_nganhang_submit_btn_btncailai"
            onClick={handleReset}
          >
            รีเซ็ต
          </button>
        </div>
      </div>

      {/* POPUP DANH SÁCH NGÂN HÀNG */}
      <BankList
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        selectedBank={selectedBank}
        setSelectedBank={setSelectedBank}
        bankList={bankList}
      />

      {/* NOTIFY */}
      {message && (
        <Notify
          message={message}
          type={type}
          setcontent={setMessage}
        />
      )}
    </>
  );
}

export default NganHang;